import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/home/Hero';
import Logos from './components/home/Logos';
import Features from './components/home/Features';
import Services from './components/home/Services';
import About from './components/about/About';
import ServicesPage from './components/services/ServicesPage'; // New import
import CTA from './components/home/CTA';
import Footer from './components/Footer';
import CreatorPage from './components/creator/CreatorPage';
import BrandPage from './components/brand/BrandPage';
import Section1 from './components/home/Section1';
import Section2 from './components/home/Section2';
import Section3 from './components/home/Section3';
import Metrics from './components/home/Metrics';
import PageBreak from './components/home/PageBreak';

//import Webinar from './components/webinar/Webinar';
import Roles from './components/forms/Roles';
import AcornsAmbassadorManager from './components/forms/AcornsAmbassadorManager';
import AcornsAmbassador from './components/forms/AcornsAmbassador';
import SolunaAmbassador from './components/forms/SolunaAmbassador';
import CreatorApp from './components/forms/CreatorApp';
import CampusAmbassador2026 from './components/forms/CampusAmbassador2026';
import ResearchAmbassador from './components/forms/ResearchAmbassador';

import './App.css';
import PrivacyPolicy from './components/legal/PrivacyPolicy';

// Layout component for consistent structure
const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

// ScrollToTop component to handle scrolling to top on route change
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Check if the current location is not the root ("/")
    if (location.pathname !== '/') {
      // Scroll to the top of the page on route change
      window.scrollTo(0, 0);
    }
  }, [location]);  // Effect runs every time the location changes

  return null;
}

function App() {
  return (
    <Router>
      {/* ScrollToTop Component added inside Router to ensure it scrolls on every route change */}
      <ScrollToTop />

      <Routes>
        {/* Home Page */}
        <Route path="/" element={
          <MainLayout>
            <Hero />
            <Logos />
            <Section1 />
            <PageBreak />
            <Metrics />
            <Section2 />
            <PageBreak />
            <Features />
            <Section3 />
            <PageBreak />
            <Services />
            <PageBreak />
            <CTA />
            <PageBreak />
          </MainLayout>
        } />

        {/* Services Page */}
        <Route path="/services" element={
          <MainLayout>
            <ServicesPage />
          </MainLayout>
        } />

        <Route path="/about" element={
          <MainLayout>
            <About />
          </MainLayout>
        } />

        {/* Creator Page */}
        <Route path="/creators" element={
          <MainLayout>
            <CreatorPage />
          </MainLayout>
        } />
        
        {/* Brand Page */}
        <Route path="/brands" element={
          <MainLayout>
            <BrandPage />
          </MainLayout>
        } />

        <Route path="/ambassador-manager" element={
          <MainLayout>
            <AcornsAmbassadorManager />
          </MainLayout>
        } />

        <Route path="/acorns-ambassador" element={
          <MainLayout>
            <AcornsAmbassador />
          </MainLayout>
        } />

        <Route path="/soluna-ambassador" element={
          <MainLayout>
            <SolunaAmbassador />
          </MainLayout>
        } />

        <Route path="/campus-ambassador-2026" element={
          <MainLayout>
            <CampusAmbassador2026 />
          </MainLayout>
        } />

        <Route path="/research-ambassador" element={
          <MainLayout>
            <ResearchAmbassador />
          </MainLayout>
        } />

        <Route path="/creator" element={
          <MainLayout>
            <CreatorApp />
          </MainLayout>
        } />

        <Route path="/roles" element={
          <MainLayout>
            <Roles />
          </MainLayout>
        } />

        <Route path="/privacy-policy" element={
          <MainLayout>
            <PrivacyPolicy />
          </MainLayout>
        } />

        {/* <Route path="/webinar" element={
          <MainLayout>
            <Webinar />
          </MainLayout>
        } /> */}
      </Routes>
    </Router>
  );
}

export default App;
